export function truncateMaxChars(str,maxChars = 13) {
  if(!str) str = 'no-name'
  if(str.length < maxChars ) return str
  else return str.substr(0,maxChars)+'(...)'
}

export function capitalize(str){
  return str.charAt(0).toUpperCase() + str.slice(1)
}
